import { ApprovalStatus } from "../../../../../../components";
import { useColumn } from "../../../Employees/hooks/use-column";
import { Form } from "antd";
import { DateFormat } from "../../../../../../constants";
import Input from "rc-input";
import { DateHelper } from "../../../../../../helper";

export const useToolGrantColumn = () => {
  const { getColumnSearchProps, isEditing } = useColumn();

  const itToolGrantColumn = [
    {
      title: "Số phiếu",
      dataIndex: "id",
      editable: false,
      align: "center" as const,
      ...getColumnSearchProps("id", "Vui lòng nhập số phiếu"),
    },
    {
      title: "Người tạo",
      dataIndex: "createdName",
      editable: false,
      width: 200,
      ...getColumnSearchProps("createdName", "Vui lòng nhập người tạo"),
    },
    {
      title: "Tiêu đề",
      dataIndex: "Title",
      editable: false,
      width: 200,
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      editable: false,
      width: 400,
    },
    {
      title: "Tình trạng",
      dataIndex: "eRequestStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Thủ trưởng CQ/ĐV",
      dataIndex: "eApprovedBy",
      editable: false,
      render: (_: any, record: any) =>
        !record.eApprovedStatus && isEditing(record) ? (
          <Form.Item
            name={"eApprovedBy"}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Vui lòng nhập thủ trưởng CQ/ĐV!`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          record.eApprovedBy
        ),
    },
    {
      title: "Trạng thái Thủ trưởng CQ/ĐV",
      dataIndex: "eApprovedStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Ngày Thủ trưởng CQ/ĐV phê duyệt",
      dataIndex: "eApprovedDate",
      editable: false,
      render: (text: string) => DateHelper.formatDateToString(text, { format: DateFormat.DD_MM_YYYY_HH_MM }),
    },
    {
      title: "Cán bộ CNTT tiếp nhận",
      dataIndex: "eApprovedByITLead",
      editable: false,
      render: (_: any, record: any) =>
        !record.eApprovedByITLeadStatus && isEditing(record) ? (
          <Form.Item
            name={"eApprovedByITLead"}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Vui lòng nhập cán bộ CNTT!`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          record.eApprovedByITLead
        ),
    },
    {
      title: "Trạng thái Cán bộ CNTT",
      dataIndex: "eApprovedByITLeadStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Ngày Cán bộ CNTT phê duyệt",
      dataIndex: "eApprovedByITLeadDate",
      editable: false,
      render: (text: string) => DateHelper.formatDateToString(text, { format: DateFormat.DD_MM_YYYY_HH_MM }),
    },
    {
      title: "Tiếp nhận / Tiến hành thực hiện",
      dataIndex: "eAssignee",
      editable: false,
      render: (_: any, record: any) =>
        !record.eAssigneeStatus && isEditing(record) ? (
          <Form.Item
            name={"eAssignee"}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Vui lòng nhập cán bộ tiếp nhận!`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          record.eAssignee
        ),
    },
    {
      title: "Trạng thái thực hiện",
      dataIndex: "eAssigneeStatus",
      editable: false,
      render: (text: string) => <ApprovalStatus status={text} />,
    },
    {
      title: "Ngày thực hiện",
      dataIndex: "eAssigneeStatusDate",
      editable: false,
      render: (text: string) => DateHelper.formatDateToString(text, { format: DateFormat.DD_MM_YYYY_HH_MM }),
    },
  ];
  return {itToolGrantColumn};
};
